/**
 * DownloadsAROrbDownloadsRoute
 *
 * Page component for DownloadsAROrbDownloadsRoute
 * Path: /ar/downloads
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { DownloadsAROrbDownloadsPageView as __DownloadsAROrbDownloadsPageView } from '@/components/traits/DownloadsAROrbDownloadsPageView';
import { DownloadsAROrbDownloadsAnalyticsView as __DownloadsAROrbDownloadsAnalyticsView } from '@/components/traits/DownloadsAROrbDownloadsAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface DownloadsAROrbDownloadsRouteProps {
  // Add any page-level props here
}

export function DownloadsAROrbDownloadsRoute(_props: DownloadsAROrbDownloadsRouteProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-orb-downloads:meta.title"],"description":["i18n/t","std-orb-downloads:meta.description"],"access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/downloads"},{"locale":"ar","path":"/ar/downloads"},{"locale":"sl","path":"/sl/downloads"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__DownloadsAROrbDownloadsPageView config={{ initPayload: __navState }} />
          <__DownloadsAROrbDownloadsAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default DownloadsAROrbDownloadsRoute;
